// import Vue from 'vue';
import { DirectiveOptions } from 'vue';
import clickoutside from './clickoutside';
import numberInput from './limit';
// 自定义指令
const directives = {
    clickoutside,
    numberInput,
};

export default {
    install(Vue: { directive: (arg0: any, arg1: any) => void }) {
        Object.keys(directives).forEach((key: any) => {
            Vue.directive(key, (directives as { [key: string]: DirectiveOptions })[key]);
        });
    },
};
